


































































import Mgr from '@/services/security';
import NotificationWidget from '@/components/NotificationWidget.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

import 'spin.js/spin.css';
import { Spinner } from 'spin.js';

@Component({ components: { NotificationWidget } })
export default class Skinned extends Vue {
  private spin = new Spinner({ color: '#111', lines: 11, length: 35, radius: 75, width: 11 });

  get fullName() {
    return this.$store.state.fullName;
  }
  get signedIn() {
    return this.$store.state.signedIn;
  }
  get devMode() {
    return this.$store.state.devMode;
  }
  get pageTitle() {
    return this.$store.state.pageTitle;
  }
  get appTitle() {
    if (this.$store.state.appTitle === '') {
      // backwards compatibility shim for legacy controls
      return 'Document Management';
    } else {
      return this.$store.state.appTitle;
    }
  }
  get hasToken() { return !!this.$store.state.accessToken; }

  public toggleDevMode() {
    this.$store.commit('toggleDevMode');
  }

  private mounted() {
    if (!this.hasToken) {
      // only start the spinner if there isn't a token
      const target = document.getElementById('spinner')!;
      this.spin.spin(target);
    }
  }

  private logout() {
    new Mgr().signOut();
  }
}
